"use strict";

const IMMEDIATE_ACTIONS = new Set(["bookmark", "cancel", "cancel-bookmark"]);
const POPUP_CLOSE_ACTIONS = new Set(["revert", "snooze", "connect", "cancel", "bookmark", "cancel-bookmark", "uninterest"]);

export function getActionBase(action) {
	return String(action || "").split("-")[0];
}

export function toActionRequest(action) {
	return action === "decline-already" ? "already" : action;
}

export function isImmediateBrandAction(action) {
	const actionBase = getActionBase(action);
	return IMMEDIATE_ACTIONS.has(action) || IMMEDIATE_ACTIONS.has(actionBase);
}

export function getBrandActionMessageTitle(action) {
	const requestAction = toActionRequest(action);
	if (requestAction === "connect") return "Request sent";
	if (requestAction === "cancel" || requestAction === "cancel-temp") return "Cancel request";
	if (requestAction === "snooze") return "Snooze";
	if (requestAction === "bookmark" || requestAction === "cancel-bookmark") return "Saved";
	return "Notification";
}

export function buildConnectActionPayload(connectMessage, partnershipInMind) {
	const data = {};
	const message = typeof connectMessage === "string" ? connectMessage.trim() : "";
	const partnerships = Array.isArray(partnershipInMind) ? partnershipInMind : [];

	if (message) data.message = message;
	if (partnerships.length > 0) data.partnerships = partnerships;

	return {
		isValid: !!message,
		data,
	};
}

export function shouldClosePopupForAction(action) {
	return POPUP_CLOSE_ACTIONS.has(toActionRequest(action));
}
